import { render, staticRenderFns } from "./iot.vue?vue&type=template&id=4afde6d5&scoped=true"
import script from "./iot.vue?vue&type=script&lang=js"
export * from "./iot.vue?vue&type=script&lang=js"
import style0 from "./iot.vue?vue&type=style&index=0&id=4afde6d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afde6d5",
  null
  
)

export default component.exports